import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  model,
  ModelSignal,
  output,
  OutputEmitterRef,
  Signal,
} from '@angular/core';
import { MatBadge, MatBadgeSize } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltip, TooltipPosition } from '@angular/material/tooltip';
import { AnimationProp } from '@fortawesome/angular-fontawesome';
import { IconComponent } from '@libs/components/icons';
import { ButtonType, IconButtonStyle } from '@libs/common/models';
import { ComponentsIconsStyle, IconName } from '@libs/shared/models';

@Component({
  selector: 'ui-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['../button/button.component.scss', './icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatBadge,
    MatTooltip,
    IconComponent,
  ],
})
export class IconButtonComponent {
  public clicked: OutputEmitterRef<void> = output();

  public type: InputSignal<ButtonType> = input<ButtonType>('button');
  public buttonStyle: InputSignal<IconButtonStyle> = input<IconButtonStyle>('filled');
  public disabled: InputSignal<boolean> = input<boolean>(false);
  public icon: InputSignal<IconName> = input.required();
  public iconStyle: InputSignal<ComponentsIconsStyle> = input<ComponentsIconsStyle>('solid');
  public small: InputSignal<boolean> = input<boolean>(false);
  public big: InputSignal<boolean> = input<boolean>(false);
  public loading: ModelSignal<boolean> = model<boolean>(false);
  public badge: InputSignal<string | undefined> = input<string | undefined>('');
  public badgeSize: InputSignal<MatBadgeSize> = input<MatBadgeSize>('medium');
  public tooltipPosition: InputSignal<TooltipPosition> = input<TooltipPosition>('below');
  public tooltip: InputSignal<string> = input<string>('');

  public currentAnimationName: Signal<AnimationProp | undefined> = computed(() => {
    return this.loading() ? 'spin' : undefined;
  });

  public currentIconName: Signal<IconName> = computed(() => {
    return this.loading() ? 'spinner-third' : this.icon();
  });

  public currentIconStyle: Signal<ComponentsIconsStyle> = computed(() => {
    return this.loading() ? 'light' : this.iconStyle();
  });
}
